import Sidebar from "../components/Sidebar";
import creator1Img from "../assets/images/creator1.png";
import Topbar from "../components/Topbar";
import FavoriteCard from "./FavoriteCard";
import { useState, useEffect } from "react";
import { API_BASE } from "../utils/Instance";
import TopCreatorsTable from "./TopCreatorsTable";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import Image1 from "../assets/contest images/image1.jpg";
import Image3 from "../assets/contest images/image3.jpg";
import Image4 from "../assets/contest images/image4.jpg";
import Image5 from "../assets/contest images/image5.jpg";
import Image6 from "../assets/contest images/image6.jpg";
import Image7 from "../assets/contest images/image7.jpg";

 const allContests = [
  {
    id: 1,
    title: "Beach Body",
    description: "Show off your elegant feet.",
    category: "Hand",
    user_joined: "75/500",
    image: Image6,
    attributes: {
      gender: "Male",
      age: "18-25",
      PenisSize: "5'",
      bodyType: "Slim",
      skinTone: "Fair",
      HairColor: "Blonde"
    },
    estimatedPrice: "$2200",
    startTime: "2025-06-01T08:00:00Z",
    endTime: "2025-06-03T08:00:00Z"
  },
  {
    id: 2,
    title: "Perfect Pose",
    description: "Submit your best legs!",
    category: "Face",
    user_joined: "100/500",
    image: Image1,
    attributes: {
      gender: "Female",
      age: "25-35",
      bustSize: "36D",
      bodyType: "Athletic",
      skinTone: "Medium",
      HairColor: "Brown"
    },
    estimatedPrice: "$1200",
    startTime: "2025-06-04T08:00:00Z",
    endTime: "2025-06-06T08:00:00Z"
  },
  {
    id: 3,
    title: "Best Chest",
    description: "Style your feet with trendy shoes.",
    category: "Foot",
    user_joined: "60/500",
    image: Image5,
    attributes: {
      gender: "Female",
      age: "20-30",
      bustSize: "36B",
      bodyType: "Petite",
      skinTone: "Tan",
      HairColor: "Black"
    },
    estimatedPrice: "$1200",
    startTime: "2025-06-07T08:00:00Z",
    endTime: "2025-06-09T08:00:00Z"
  },
  {
    id: 4,
    title: "Nicest legs",
    description: "Show off your toned body ready for the beach.",
    category: "Body",
    user_joined: "120/500",
    image: Image3,
    attributes: {
      gender: "Female",
      age: "22-28",
      PenisSize: "6.5'",
      bodyType: "Muscular",
      skinTone: "Olive",
      HairColor: "Olive"
    },
    estimatedPrice: "$2200",
    startTime: "2025-06-10T08:00:00Z",
    endTime: "2025-06-13T08:00:00Z"
  },
  {
    id: 5,
    title: "Cutest Feets",
    description: "Strike your best formal evening look.",
    category: "Pose",
    user_joined: "90/500",
    image: Image5,
    attributes: {
      gender: "Female",
      age: "30-40",
      bustSize: "36C",
      bodyType: "Curvy",
      skinTone: "Light",
      HairColor: "Blonde"
    },
    estimatedPrice: "$1200",
    startTime: "2025-06-15T08:00:00Z",
    endTime: "2025-06-18T08:00:00Z"
  },
  {
    id: 6,
    title: "Runway Ready",
    description: "Walk your best walk and pose like a model.",
    category: "Fashion",
    user_joined: "110/500",
    image: Image4,
    attributes: {
      gender: "Other",
      age: "20-35",
      bustSize: "36B",
      bodyType: "Tall",
      skinTone: "Brown",
      HairColor: "Blonde"
    },
    estimatedPrice: "$1200",
    startTime: "2025-06-20T08:00:00Z",
    endTime: "2025-06-23T08:00:00Z"
  },
  {
    id: 8,
    title: "Prettiest V",
    description: "Walk your best walk and pose like a model.",
    category: "Fashion",
    user_joined: "120/500",
    image: Image7,
    attributes: {
      gender: "Female",
      age: "20-35",
      bustSize: "36B",
      bodyType: "Tall",
      skinTone: "Brown",
      HairColor: "Blonde"
    },
    estimatedPrice: "$1000",
    startTime: "2025-06-20T08:00:00Z",
    endTime: "2025-06-23T08:00:00Z"
  },
  {
    id: 9,
    title: "Best Figure",
    description: "Walk your best walk and pose like a model.",
    category: "Fashion",
    user_joined: "110/500",
    image: Image6,
    attributes: {
      gender: "Male",
      age: "20-35",
      PenisSize: "5.5'",
      bodyType: "Tall",
      skinTone: "Brown",
      HairColor: "Blonde"
    },
    estimatedPrice: "$2500",
    startTime: "2025-06-20T08:00:00Z",
    endTime: "2025-06-23T08:00:00Z"
  }

];

const top_creators = [
  {
    name: "Alina Batosh",
    avatar: creator1Img,
    contests_joined: 310,
    votes: 290,
    contests_win: 80,
    galleries_completed: "7 of 7",
    trophyCount: 3,
    badgeCount: 13,
    top3Finishes: 6,     // 3 * 2
    top10Finishes: 13,   // same as badgeCount
  },
  {
    name: "John Smith",
    avatar: creator1Img,
    contests_joined: 270,
    votes: 250,
    contests_win: 75,
    galleries_completed: "5 of 7",
    trophyCount: 2,
    badgeCount: 10,
    top3Finishes: 4,
    top10Finishes: 10,
  },
  {
    name: "Lana Rose",
    avatar: creator1Img,
    contests_joined: 310,
    votes: 320,
    contests_win: 60,
    galleries_completed: "6 of 7",
    trophyCount: 4,
    badgeCount: 9,
    top3Finishes: 8,
    top10Finishes: 9,
  },
  {
    name: "Kevin Hart",
    avatar: creator1Img,
    contests_joined: 290,
    votes: 215,
    contests_win: 45,
    galleries_completed: "4 of 7",
    trophyCount: 1,
    badgeCount: 4,
    top3Finishes: 2,
    top10Finishes: 4,
  },
  {
    name: "Maya Ali",
    avatar: creator1Img,
    contests_joined: 350,
    votes: 400,
    contests_win: 90,
    galleries_completed: "7 of 7",
    trophyCount: 5,
    badgeCount: 15,
    top3Finishes: 10,
    top10Finishes: 15,
  },
];

// favoritedGalleries will be computed from favoritedImages

export default function DashboardJudge() {
  const [favoritedImages, setFavoritedImages] = useState([]);
  const [favoritedGalleries, setFavoritedGalleries] = useState([]);
  const [selectedGallery, setSelectedGallery] = useState(null);
  const [allGalleryImages, setAllGalleryImages] = useState([]);
  const [loadingGallery, setLoadingGallery] = useState(false);
  const [joinedContestIds, setJoinedContestIds] = useState([]);
  const [showJoinModal, setShowJoinModal] = useState(false);
  const [selectedContestToJoin, setSelectedContestToJoin] = useState(null);
  const [isJoining, setIsJoining] = useState(false);
  const [popularContests, setPopularContests] = useState([]);
  const [topContributors, setTopContributors] = useState([]);
  const [loadingContributors, setLoadingContributors] = useState(true);
  const navigate = useNavigate();
  const { profile } = useAuth();

  const normalizeGalleryImage = (image) => ({
    ...image,
    id: image?.body_part_image_id || image?.id,
    image_url: image?.image_url || image?.image || image?.url || "",
  });
  
  // Compute gallery cards from favorite galleries API plus a sample image from favorites
  const computeGalleriesFromFavorites = (galleryFavorites, imageFavorites) => {
    const grouped = {};

    galleryFavorites.forEach((fav) => {
      const contributorKey = fav.contributor_screen_name || fav.contributor_name || "Unknown";
      const contributorId = fav.contributor; // profile id
      const bodyPart = fav.body_part || "General";
      const key = `${contributorId}-${bodyPart}`;

      if (!grouped[key]) {
        // Pick any image from this contributor + body part as thumbnail if we have it
        const matchingImage = imageFavorites.find(
          (img) =>
            img.contributor_id === contributorId &&
            (img.body_part || "").toLowerCase() === bodyPart.toLowerCase()
        );

        grouped[key] = {
          id: key,
          title: `${bodyPart} Gallery`,
          creator: contributorKey,
          contributorId: contributorId,
          bodyPart: bodyPart,
          image: matchingImage?.image_url || creator1Img,
          itemsCount: 0,
          images: [],
        };
      }
    });

    // Count how many favorited images fall into each gallery (for display only)
    imageFavorites.forEach((fav) => {
      const contributorId = fav.contributor_id;
      const bodyPart = fav.body_part || "General";
      const galleryKey = `${contributorId}-${bodyPart}`;
      if (grouped[galleryKey]) {
        grouped[galleryKey].itemsCount += 1;
        grouped[galleryKey].images.push(normalizeGalleryImage(fav));
      }
    });

    return Object.values(grouped);
  };
  
  // Fetch all images from a specific contributor's gallery
  const fetchGalleryImages = async (contributorId, bodyPart) => {
    try {
      setLoadingGallery(true);
      const token = profile?.accessToken;
      
      if (!token) return;
      
      // Fetch all contributors to find the specific one
      const response = await fetch(`${API_BASE}accounts/contributors/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        const contributor = data.contributors.find(c => c.id === contributorId);
        
        if (contributor && contributor.photoGallery && contributor.photoGallery[bodyPart]) {
          setAllGalleryImages(contributor.photoGallery[bodyPart].map(normalizeGalleryImage));
        } else {
          setAllGalleryImages([]);
        }
      }
    } catch (error) {
      console.error('Error fetching gallery images:', error);
      setAllGalleryImages([]);
    } finally {
      setLoadingGallery(false);
    }
  };
  
  // Handle gallery click
  const handleGalleryClick = (gallery) => {
    setSelectedGallery(gallery);
    if (gallery.contributorId && gallery.bodyPart) {
      fetchGalleryImages(gallery.contributorId, gallery.bodyPart);
    } else {
      // Fallback to just showing favorited images
      setAllGalleryImages((gallery.images || []).map(normalizeGalleryImage));
    }
  };

  const mapContributorForExplore = (contributor, creatorSummary = {}) => ({
    id: contributor.id,
    name: contributor.screen_name || contributor.name || creatorSummary.name,
    img: contributor.avatar || contributor.profile_picture || contributor.profilePicture || creatorSummary.avatar,
    age: contributor.age,
    gender: contributor.gender,
    bust: contributor.bust_size || contributor.bustSize,
    penisSize: contributor.penis_size || contributor.penisSize,
    bodyType: contributor.body_type || contributor.bodyType,
    hairColor: contributor.hair_color || contributor.hairColor,
    skinTone: contributor.skin_tone || contributor.skinTone,
    height: contributor.height,
    weight: contributor.weight,
    shoeSize: contributor.shoe_size || contributor.shoeSize,
    contests: contributor.contests || contributor.contests_count || contributor.contestsCount || creatorSummary.contests_joined || 0,
    badges: contributor.badges || contributor.badges_count || contributor.badgesCount || creatorSummary.contests_win || 0,
    top10: contributor.top10 || contributor.top10Finishes || creatorSummary.top10Finishes || 0,
    photoGalleries: contributor.photo_galleries || contributor.photoGalleries || creatorSummary.galleries_completed || "0 of 7",
    photoGallery: contributor.photoGallery || {},
  });

  const handleTopContributorClick = async (creator) => {
    const creatorName = creator.name || creator.screen_name || "Contributor";
    const token = profile?.accessToken;

    if (!token) {
      navigate(`/explore-content?search=${encodeURIComponent(creatorName)}`);
      return;
    }

    try {
      const response = await fetch(`${API_BASE}accounts/contributors/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Contributor lookup failed with status ${response.status}`);
      }

      const data = await response.json();
      const contributors = data.contributors || data.results || (Array.isArray(data) ? data : []);
      const selectedContributor = contributors.find((contributor) => String(contributor.id) === String(creator.id))
        || contributors.find((contributor) => {
          const screenName = contributor.screen_name || contributor.name || "";
          return screenName.toLowerCase() === creatorName.toLowerCase();
        });

      if (selectedContributor) {
        navigate("/explore-content", {
          state: {
            selectedContributor: mapContributorForExplore(selectedContributor, creator),
          },
        });
        return;
      }
    } catch (error) {
      console.error("Error opening contributor from dashboard:", error);
    }

    navigate(`/explore-content?search=${encodeURIComponent(creatorName)}`);
  };
  
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setSelectedGallery(null);
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);
  
  useEffect(() => {
    const token = profile?.accessToken;
    if (!token) return;
    
    // Load both lists together so purchased gallery cards use fresh thumbnails/counts.
    Promise.all([
      fetch(`${API_BASE}accounts/favorites/`, {
        headers: { Authorization: `Bearer ${token}` },
      }).then((r) => r.json()),
      fetch(`${API_BASE}accounts/favorite-galleries/`, {
        headers: { Authorization: `Bearer ${token}` },
      }).then((r) => r.json()),
    ])
      .then(([images, galleries]) => {
        const safeImages = Array.isArray(images) ? images : [];
        const safeGalleries = Array.isArray(galleries) ? galleries : [];
        setFavoritedImages(safeImages);
        setFavoritedGalleries(computeGalleriesFromFavorites(safeGalleries, safeImages));
      })
      .catch((err) => {
        console.error("Error loading favorites:", err);
      });

    // Fetch joined contests
    fetch(`${API_BASE}accounts/contests/my-contests/`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((contests) => {
        const joinedIds = contests.map(c => c.id);
        console.log('Joined contest IDs:', joinedIds);
        setJoinedContestIds(joinedIds);
      })
      .catch((err) => {
        console.error("Error loading joined contests:", err);
      });

    // Fetch popular/active contests from API
    fetch(`${API_BASE}accounts/contests/?t=${Date.now()}`, { 
      headers: { Authorization: `Bearer ${token}` },
      cache: 'no-store'
    })
      .then((r) => r.json())
      .then((contests) => {
        // Get active contests for Popular Contests section
        const activeContests = contests.filter(c => c.is_active === true).slice(0, 8);
        console.log('Popular contests:', activeContests);
        setPopularContests(activeContests);
      })
      .catch((err) => {
        console.error("Error loading popular contests:", err);
      });

    // Fetch top contributors from API
    fetch(`${API_BASE}accounts/dashboard/top-contributors/`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => {
        console.log('Top contributors API response status:', r.status);
        if (!r.ok) {
          throw new Error(`API returned status ${r.status}`);
        }
        return r.json();
      })
      .then((data) => {
        console.log('✅ Top contributors data received from API:', data);
        console.log('Number of contributors:', data.length);
        if (data.length > 0) {
          console.log('📊 First contributor galleries_completed:', data[0].galleries_completed);
        }
        setTopContributors(data);
        setLoadingContributors(false);
      })
      .catch((err) => {
        console.error("❌ Error loading top contributors:", err);
        console.log('⚠️ Falling back to hardcoded dummy data (top_creators)');
        setLoadingContributors(false);
        // Fallback to empty array if fetch fails
        setTopContributors([]);
      });
  }, [profile]);

  // Toggle favorite for gallery images
  const toggleGalleryImageFavorite = async (imageId) => {
    try {
      const token = profile?.accessToken;
      if (!token) {
        toast.error("Please login to favorite images");
        return;
      }

      // Check if already favorited
      const isFavorited = favoritedImages.some(fav => fav.body_part_image_id === imageId);

      if (isFavorited) {
        // Remove from favorites - DELETE method with ID in URL
        const response = await fetch(`${API_BASE}accounts/favorites/remove/${imageId}/`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok || response.status === 204) {
          // Update local state
          setFavoritedImages(prev => prev.filter(fav => fav.body_part_image_id !== imageId));
          toast.success('Removed from favorites');
        }
      } else {
        // Add to favorites
        const response = await fetch(`${API_BASE}accounts/favorites/add/`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ body_part_image_id: imageId })
        });

        if (response.ok) {
          // Fetch updated favorites to keep in sync
          const favResponse = await fetch(`${API_BASE}accounts/favorites/`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          
          if (favResponse.ok) {
            const data = await favResponse.json();
            setFavoritedImages(data);
            // Update galleries using new helper
            setFavoritedGalleries(prev =>
              computeGalleriesFromFavorites(
                prev.map(g => ({
                  // reconstruct minimal FavoriteGallery-like objects from existing cards
                  contributor: g.contributorId,
                  body_part: g.bodyPart,
                  contributor_screen_name: g.creator,
                })),
                data
              )
            );
          }
          
          toast.success('Added to favorites ❤️');
        }
      }
    } catch (error) {
      console.error('Error toggling favorite:', error);
      toast.error('Failed to update favorites');
    }
  };

  // Handle join contest button click
  const handleJoinClick = (contest) => {
    console.log('Join button clicked for contest:', contest);
    setSelectedContestToJoin(contest);
    setShowJoinModal(true);
  };

  // Confirm join contest
  const handleConfirmJoin = async () => {
    console.log('handleConfirmJoin called');
    if (!selectedContestToJoin) {
      console.log('No contest selected, returning');
      return;
    }
    
    console.log('Joining contest:', selectedContestToJoin.title);
    
    try {
      setIsJoining(true);
      const token = profile?.accessToken;
      
      const response = await fetch(
        `${API_BASE}accounts/contests/${selectedContestToJoin.id}/join/`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.ok) {
        const data = await response.json();
        
        // Add to joined contests
        setJoinedContestIds(prev => [...prev, selectedContestToJoin.id]);
        
        // Check if already joined or newly joined
        if (!data.already_joined) {
          toast.success(`✅ Successfully joined "${selectedContestToJoin.title}"!`);
        }
        
        // Close modal
        setShowJoinModal(false);
        setSelectedContestToJoin(null);
        
        // Check if contest has started - use data from backend response
        const contestHasStarted = data.contest_has_started === true;
        const needsWaitingRoom = data.waiting_room === true;
        
        if (contestHasStarted) {
          // Contest is live - proceed to voting panel
          if (data.already_joined) {
            navigate(`/photo-voting/${selectedContestToJoin.id}`);
          } else {
            setTimeout(() => {
              navigate(`/photo-voting/${selectedContestToJoin.id}`);
            }, 1000);
          }
        } else if (needsWaitingRoom) {
          // Contest hasn't started - redirect to waiting room
          toast.success("✅ Entry confirmed! Redirecting to waiting room...");
          setTimeout(() => {
            navigate(`/waiting-room/${selectedContestToJoin.id}`);
          }, 1000);
        } else {
          // No start time set - proceed to voting (legacy behavior)
          if (data.already_joined) {
            navigate(`/photo-voting/${selectedContestToJoin.id}`);
          } else {
            setTimeout(() => {
              navigate(`/photo-voting/${selectedContestToJoin.id}`);
            }, 1000);
          }
        }
      } else {
        const errorData = await response.json();
        
        if (errorData.error && errorData.error.includes("already joined")) {
          toast.warning(`⚠️ Already joined "${selectedContestToJoin.title}"`);
          // Check if we need waiting room or voting panel
          // Try to fetch contest details to check start time
          const contestResponse = await fetch(
            `${API_BASE}accounts/contests/${selectedContestToJoin.id}/`,
            {
              headers: {
                'Authorization': `Bearer ${token}`,
              }
            }
          );
          if (contestResponse.ok) {
            const contestData = await contestResponse.json();
            const now = new Date();
            const startTime = contestData.start_time ? new Date(contestData.start_time) : null;
            const hasStarted = startTime && now >= startTime;
            
            if (hasStarted) {
              navigate(`/photo-voting/${selectedContestToJoin.id}`);
            } else if (startTime) {
              navigate(`/waiting-room/${selectedContestToJoin.id}`);
            } else {
              navigate(`/photo-voting/${selectedContestToJoin.id}`);
            }
          } else {
            navigate(`/photo-voting/${selectedContestToJoin.id}`);
          }
        } else {
          toast.error(`❌ ${errorData.detail || errorData.error || "Failed to join contest"}`);
        }
        
        setShowJoinModal(false);
        setSelectedContestToJoin(null);
      }
    } catch (error) {
      console.error("Error joining contest:", error);
      toast.error("❌ An error occurred while joining the contest");
      setShowJoinModal(false);
      setSelectedContestToJoin(null);
    } finally {
      setIsJoining(false);
    }
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-black">
      <Sidebar />
      <div className="flex-1 p-3 md:p-6 lg:ml-64 w-full">
        <Topbar pageTitle="Dashboard" />

        {/* Images Favorited Section */}
        <div className="py-5 md:py-10">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg md:text-xl font-semibold font-inter text-[#ceb46a]">
              Images Favorited ({favoritedImages.length})
            </h2>
            <button
              onClick={() => navigate('/favorited-images')}
              className="text-[#ceb46a] hover:text-[#d6c074] text-sm font-medium transition-colors duration-200 flex items-center gap-1"
            >
              See All
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
          <div className="overflow-x-auto pb-3 -mx-1 px-1">
            <div className="flex gap-4">
            {favoritedImages.length > 0 ? (
              favoritedImages.map((favorite) => (
                <div key={favorite.id} className="w-56 sm:w-64 flex-shrink-0">
                  <FavoriteCard
                    avatar={favorite.image_url || creator1Img}
                    isFavorite={true}
                    contributorName={favorite.contributor_screen_name || favorite.contributor_name}
                    bodyPart={favorite.body_part}
                    onToggleFavorite={() => {
                      // Remove from favorites via API
                      const token = profile?.accessToken;
                      if (token) {
                        fetch(`${API_BASE}accounts/favorites/toggle/`, {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                          },
                          body: JSON.stringify({
                            body_part_image_id: favorite.body_part_image_id,
                          }),
                        }).then(() => {
                          // Remove from local state
                          setFavoritedImages(prev => prev.filter(fav => fav.id !== favorite.id));
                        });
                      }
                    }}
                  />
                </div>
              ))
            ) : (
              <div className="w-full text-center text-gray-400 py-8">
                No favorited images yet. Start favoriting images from contests!
              </div>
            )}
            </div>
          </div>
        </div>

        {/* Galleries Purchased Section */}
        <div className="py-5 md:py-10">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg md:text-xl font-semibold text-[#ceb46a]">
              Galleries Purchased
            </h2>
            <button
              onClick={() => navigate('/favorited-galleries')}
              className="text-[#ceb46a] hover:text-[#d6c074] text-sm font-medium transition-colors duration-200 flex items-center gap-1"
            >
              See All
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          <div className="overflow-x-auto pb-3 -mx-1 px-1">
            <div className="flex gap-4">
            {favoritedGalleries.length > 0 ? (
              favoritedGalleries.map((gallery) => (
              <div
                key={gallery.id}
                className="bg-[#1c1c1c] rounded-lg overflow-hidden shadow-md cursor-pointer hover:shadow-lg transition-shadow relative w-64 sm:w-72 flex-shrink-0"
                onClick={() => handleGalleryClick(gallery)}
              >
                <img
                  src={gallery.image}
                  alt={gallery.title}
                  className="w-full h-32 object-cover"
                />
                <div className="p-4">
                  <h3 className="text-white text-lg font-semibold">
                    {gallery.title}
                  </h3>
                  <p className="text-sm text-gray-400">by {gallery.creator}</p>
                  <div className="mt-1 flex items-center justify-between">
                    <p className="text-xs text-[#ceb46a]">
                      {gallery.itemsCount} purchased
                    </p>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleGalleryClick(gallery);
                      }}
                      className="transition-all duration-200 transform hover:scale-105 border border-black bg-[#ceb46a] text-black text-xs px-3 py-1 rounded-full font-semibold shadow hover:bg-[#d6c074]"
                    >
                      View Gallery
                    </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="w-full text-center text-gray-400 py-8">
                No purchased galleries yet. Start exploring contributor galleries!
              </div>
            )}
            </div>
          </div>

          {/* Modal - Gallery Images Grid - Shows ALL images from gallery */}
          {selectedGallery && (
            <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center px-4">
              <div className="bg-[#1c1c1e] w-full max-w-4xl max-h-[90vh] overflow-y-auto p-6 rounded-xl relative shadow-lg border border-[#ceb46a]">
                <button
                  onClick={() => {
                    setSelectedGallery(null);
                    setAllGalleryImages([]);
                  }}
                  className="absolute top-3 right-3 text-[#ceb46a] text-2xl hover:text-white transition-colors z-10"
                >
                  ×
                </button>
                
                <h3 className="text-2xl text-[#ceb46a] font-bold mb-2 text-center">
                  {selectedGallery.title}
                </h3>
                <p className="text-sm text-gray-400 mb-2 text-center">
                  by {selectedGallery.creator}
                </p>
                <p className="text-xs text-[#ceb46a] mb-6 text-center">
                  All images from this gallery • {allGalleryImages.length} total
                </p>
                
                {loadingGallery ? (
                  <div className="flex flex-col items-center justify-center py-20">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#ceb46a] mb-4"></div>
                    <p className="text-gray-400">Loading gallery images...</p>
                  </div>
                ) : allGalleryImages && allGalleryImages.length > 0 ? (
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                    {allGalleryImages.map((image, idx) => {
                      // Check if this image is in favorites
                      const normalizedImage = normalizeGalleryImage(image);
                      const imageUrl = normalizedImage.image_url;
                      const isFavorited = favoritedImages.some(fav => fav.body_part_image_id === normalizedImage.id);
                      
                      return (
                        <div
                          key={normalizedImage.id || idx}
                          className="relative group"
                        >
                          <img
                            src={imageUrl || creator1Img}
                            alt={`${selectedGallery.title} ${idx + 1}`}
                            className="w-full h-48 object-cover rounded-lg border-2 border-[#ceb46a] hover:border-white transition-all cursor-pointer"
                            onClick={() => {
                              if (imageUrl) window.open(imageUrl, '_blank', 'noopener,noreferrer');
                              else toast.error('Image URL is unavailable');
                            }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200"><rect fill="%23333" width="200" height="200"/><text x="50%" y="50%" font-size="14" text-anchor="middle" dy=".3em" fill="%23ceb46a">Image Error</text></svg>';
                            }}
                          />
                          
                          {/* Clickable Heart Icon - Always visible */}
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleGalleryImageFavorite(normalizedImage.id);
                            }}
                            className="absolute top-2 right-2 bg-black bg-opacity-60 hover:bg-opacity-80 p-2 rounded-full transition-all z-10"
                            title={isFavorited ? "Remove from favorites" : "Add to favorites"}
                          >
                            {isFavorited ? (
                              // Filled red heart for favorited images
                              <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                              </svg>
                            ) : (
                              // Outlined gray heart for non-favorited images
                              <svg className="w-5 h-5 text-gray-300" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
                              </svg>
                            )}
                          </button>
                          
                          {/* Hover Overlay */}
                          <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all rounded-lg flex items-center justify-center pointer-events-none">
                            <span className="text-white opacity-0 group-hover:opacity-100 font-semibold text-sm">
                              Click to View Full Size
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center py-10 text-gray-400">
                    No images available in this gallery
                  </div>
                )}
                
                <div className="mt-6 flex justify-center gap-3">
                  <button
                    onClick={() => navigate('/explore-content')}
                    className="px-6 py-2 bg-[#ceb46a] text-black rounded-lg font-semibold hover:bg-[#d6c074] transition-colors"
                  >
                    Explore More Galleries
                  </button>
                  <button
                    onClick={() => {
                      setSelectedGallery(null);
                      setAllGalleryImages([]);
                    }}
                    className="px-6 py-2 border-2 border-[#ceb46a] text-[#ceb46a] rounded-lg font-semibold hover:bg-[#ceb46a] hover:text-black transition-colors"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>  
        <div className="py-5 md:py-10">
          {loadingContributors ? (
            <div className="flex flex-col items-center justify-center py-20">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#ceb46a] mb-4"></div>
              <p className="text-gray-400">Loading top contributors...</p>
            </div>
          ) : (
            <>
              {console.log('🔍 Rendering table with data:', topContributors.length > 0 ? topContributors : top_creators)}
              <TopCreatorsTable
                title="Top Contributors"
                data={topContributors.length > 0 ? topContributors : top_creators}
                onCreatorClick={handleTopContributorClick}
              />
            </>
          )}
        </div>




 {/* Popular Contests Section */}
<div className="py-5 md:py-10">
  <h2 className="text-lg md:text-xl font-semibold text-[#ceb46a] mb-4">
    Popular Contests
  </h2>
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
    {(popularContests.length > 0 ? popularContests : allContests).map((contest) => (
      <div
        key={contest.id}
        className="bg-[#1c1c1c] rounded-lg overflow-hidden shadow-md"
      >
        {/* Contest Image */}
        <div className="relative">
          <img
            src={contest.image || Image1} // Contest-specific image or fallback
            alt={contest.title}
            className="w-full h-80 object-cover"
          />
          {/* Recurring Badge */}
          {contest.recurring && contest.recurring !== "none" && (
            <div className="absolute top-3 right-3 z-10">
              <span className="px-3 py-1 rounded-md text-xs font-bold bg-[#CEB46A] text-black shadow-lg uppercase">
                {contest.recurring === "daily" ? "Daily" 
                  : contest.recurring === "weekly" ? "Weekly"
                  : contest.recurring === "monthly" ? "Monthly"
                  : contest.recurring}
              </span>
            </div>
          )}
        </div>

       <div className="p-4">
  {/* Contest Title */}
  <h3 className="text-white text-lg font-semibold">
    {contest.title}
  </h3>

  {/* Contest Category */}
  <p className="text-xs text-[#ceb46a]">{contest.category || 'General'}</p>

  {/* User Joined */}
  <p className="text-xs text-gray-400 mt-1">
    Participants: {contest.participants_count || contest.user_joined || 0}/{contest.max_participants || 500}
  </p>

  {/* Time Left */}
  <p className="text-xs text-gray-400 mt-1">
    End Time:{" "}
    {contest.end_time ? new Date(contest.end_time).toLocaleString("en-US", {
      hour12: true,
    }) : contest.endTime ? new Date(contest.endTime).toLocaleString("en-US", {
      hour12: true,
    }) : 'TBA'}
  </p>

  <div className="mt-1 flex items-center justify-between">
    {/* Always show Join Button */}
    <button 
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Join button clicked for contest:', contest.id);
        handleJoinClick(contest);
        return false;
      }}
      className="bg-[#ceb46a] text-black text-xs px-3 py-1 rounded font-semibold hover:bg-[#e3c97a] transition"
      type="button"
    >
      Join
    </button>
  </div>
</div>

      </div>
    ))}
  </div>
</div>

{/* Join Contest Confirmation Modal */}
{showJoinModal && selectedContestToJoin && (
  <div 
    className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999]"
    onClick={(e) => {
      console.log('Backdrop clicked');
      // Only close if clicking the backdrop, not the modal content
      if (e.target === e.currentTarget) {
        setShowJoinModal(false);
        setSelectedContestToJoin(null);
      }
    }}
  >
    <div 
      className="bg-white rounded-lg p-6 w-[90%] max-w-md text-black shadow-2xl"
      onClick={(e) => e.stopPropagation()}
    >
      <h2 className="text-lg font-semibold mb-4 text-[#ceb46a]">Confirm Join Contest</h2>
      <p className="mb-2">
        Do you want to join contest?
      </p>
      <p className="text-gray-400 text-sm mb-4">
        Contest: <strong className="text-[#ceb46a]">{selectedContestToJoin.title}</strong>
      </p>
      <div className="flex justify-end gap-2">
        <button
          onClick={(e) => {
            e.stopPropagation();
            console.log('Cancel clicked');
            setShowJoinModal(false);
            setSelectedContestToJoin(null);
          }}
          className="px-4 py-2 border rounded text-gray-700 border-gray-400 hover:bg-gray-100 transition"
          disabled={isJoining}
          type="button"
        >
          Cancel
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            console.log('Confirm Join clicked');
            handleConfirmJoin();
          }}
          className="px-4 py-2 bg-[#ceb46a] text-black rounded hover:bg-[#e3c97a] disabled:opacity-50 disabled:cursor-not-allowed transition"
          disabled={isJoining}
          type="button"
        >
          {isJoining ? "Joining..." : "Confirm"}
        </button>
      </div>
    </div>
  </div>
)}

      </div>
    </div>
  );
}
